(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('GlobalExpenseTypeDialogController', GlobalExpenseTypeDialogController);

    GlobalExpenseTypeDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'GlobalExpenseType'];

    function GlobalExpenseTypeDialogController ($scope, $stateParams, $uibModalInstance, entity, GlobalExpenseType) {
        var vm = this;
        vm.globalExpenseType = entity;
        vm.load = function(id) {
            GlobalExpenseType.get({id : id}, function(result) {
                vm.globalExpenseType = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:globalExpenseTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.globalExpenseType.id !== null) {
                GlobalExpenseType.update(vm.globalExpenseType, onSaveSuccess, onSaveError);
            } else {
                GlobalExpenseType.save(vm.globalExpenseType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
